import { TextInput, Title, Text, Container, Button, Flex, Card, Box } from "@mantine/core";
import axios from "axios";
import React, { useState } from "react";
import { useForm } from "@mantine/form";
import { toast } from "react-hot-toast";

export default function FindPassword() {
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      username: "",
      password: "",
      email: "",
      name: "",
      phoneNumber: "",
    },
  });
  const handleSubmit = async (data) => {
    try {
      setLoading(true);
      const res = await axios({
        url: "/auth/forgot-password",
        method: "POST",
        data: {
          email: data.email,
        },
      });
      console.log(res);
      toast.success("비밀번호 초기화 링크를 보내드렸습니다");
    } catch (error) {
      console.log(error);
      toast.error("이메일 전송에 실패했습니다. 잠시 후 다시 시도해주세요");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={(theme) => ({ backgroundColor: theme.fn.rgba(theme.colors.brand[0], 0.3) })}>
      <Container size="xs">
        <Flex direction="column" justify="center" h={window.innerHeight}>
          <Card withBorder shadow="md" p={30} radius="md">
            <Title order={2} weight={900} ta="center" mb="xs">
              비밀번호 찾기
            </Title>
            <Text color="dimmed" size="sm" ta="center" mb="lg">
              가입한 이메일 주소를 통해서 비밀번호를 찾을 수 있습니다
            </Text>

            <form onSubmit={form.onSubmit(handleSubmit)}>
              <TextInput
                label="이메일 주소"
                placeholder="이메일을 입력해주세요"
                required
                {...form.getInputProps("email")}
                autoComplete="email"
                type="email"
              />
              <Button mt="sm" sx={{ float: "right" }} type="submit" loading={loading}>
                이메일 인증하기
              </Button>
            </form>
          </Card>
        </Flex>
      </Container>
    </Box>
  );
}
